import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import ReconciliationRequestsBasicInfoComponent from "./reconciliation-request-basic-info.component";

export const ReconciliationRequestPopup = ({ 
  selectedReconciliationRequest,
  closeModal,
  handleSaveReconciliationRequest,
}: any) => {
  console.log('selectedReconciliationRequest', selectedReconciliationRequest)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedReconciliationRequest));

    const handleLocalFormChange = ({path, value}: any) => {
      // setLocalAttribute(prev => ({
      //   ...prev,
      //   [field]: value,
      // }));
      console.log('selectedReconciliationRequest, path, value', selectedReconciliationRequest, path, value)
      const updatedData = updateNestedValue(selectedReconciliationRequest, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveReconciliationRequest(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <ReconciliationRequestsBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedReconciliationRequest={selectedReconciliationRequest}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }